import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { FeedbackType } from 'app/feedback/models/feedback-config.model';
import { FeedbackService } from 'app/feedback/services/feedback.service';
import { JoinrsAiModel } from 'app/interfaces/joinrs-ai.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-preview-joinrs-ai',
  templateUrl: './preview-joinrs-ai.component.html',
  styleUrls: ['./preview-joinrs-ai.component.scss']
})
export class PreviewJoinrsAiComponent implements OnInit {
  @Input() public jo: JoinrsAiModel;
  @ViewChild('previewJoinrsAiModal') template: TemplateRef<any>;

  modalRef: BsModalRef;
  constructor(
    private modalService: BsModalService,
    private feedbackService: FeedbackService,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
  }

  openPreview(): void {
    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-lg modal-xl'
    });
    // console.log(this.jo)
  }

  modalClose() {
    this.modalRef.hide();
  }

  feedback() {
    this.feedbackService.open({
      type: FeedbackType.JOBOFFER,
      modal: {
        title: `Your opinion matters to us!`,
        mainText: `Kindly <span class="text-primary">rate</span> our services based on your overall experience`,
        modalClass: "modal-lg",
        avoidClose: false,
        onSuccess: () =>
          this.toasterService.popAsync(
            "success",
            "Success",
            "Feedback sent correctly."
          ),
        onError: () =>
          this.toasterService.popAsync(
            "error",
            "Error",
            "Internal Server Error, please try again later."
          ),
      },
      extraFeedbackValues: [
        {
          key: 'job-offer-id',
          value: this.jo.id
        }
      ],
    });
  }

}
